module.exports = __webpack_public_path__ + "static/img/logo.c649caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 180